// Single source of truth for the workflows list sortable columns, shared
// between the route's `validateSearch` schema and the table so the two can't
// drift out of sync.
export const WORKFLOW_DEFINITION_SORT_FIELDS = [
  'name',
  'status',
  'createdAt',
  'updatedAt',
  'lastRun',
] as const;

export type WorkflowDefinitionSortField =
  (typeof WORKFLOW_DEFINITION_SORT_FIELDS)[number];

export function toWorkflowDefinitionSortField(
  id: string | undefined,
): WorkflowDefinitionSortField | undefined {
  if (!id) return undefined;
  for (const field of WORKFLOW_DEFINITION_SORT_FIELDS) {
    if (field === id) return field;
  }
  return undefined;
}
